import adminApi from '../../apis/adminApi';

export async function adminGetTicketsService({ page, values = {} }) {
  return adminApi.post('/api/admin/tickets', values, {
    params: {
      page: page || 1,
    },
  });
}

export async function adminRefundTicketsService(id) {
  return adminApi.post(`/api/admin/tickets/${id}/refund`).then((response) => response.data);
}
